/**
 * API Configuration
 * Works with both Vite (import.meta.env) and CRA (process.env)
 */

// Get the API URL from environment variables
const getApiUrl = () => {
  // Vite environment variable
  if (typeof import.meta !== 'undefined' && import.meta.env?.VITE_API_URL) {
    return import.meta.env.VITE_API_URL;
  }
  
  // CRA style environment variable (for backwards compatibility)
  if (typeof process !== 'undefined' && process.env?.REACT_APP_BACKEND_URL) {
    return process.env.REACT_APP_BACKEND_URL;
  }
  
  // Fallback to window origin
  return window.location.origin;
};

export const API_URL = getApiUrl();
export const API_BASE = `${API_URL}/api`;

// WebSocket URL helper
export const getWsUrl = (path = '') => {
  const wsProtocol = API_URL.startsWith('https') ? 'wss' : 'ws';
  const host = API_URL.replace(/^https?:\/\//, '');
  return `${wsProtocol}://${host}${path}`;
};

export default API_URL;
// Build 1772616859
